module.exports = __webpack_public_path__ + "static/media/4.5f6fcad3.jpg";